<div class="titulo" style="margin: 0 auto;text-align: center;margin-top: 50px;">

    <h3><b>Reporte de entradas </b></h3>
<hr>
</div>

<div class="contendor d-flex justify-content-center align-items-center" style="width: 90%;margin: 0 auto;">

    <form (ngSubmit)="GeneraReporte(f)" #f="ngForm" style="width: 80%;" >

    <div class="form-row mt-5">
   
      
      <div class="form-group col-md-2">
        <label for="inputPassword4">Fecha Inicial</label>
         <input [(ngModel)]="reporte.fechaIni" type="date" class="form-control" name="FechaIni" id="inputAddress" placeholder="" required #FechaIni="ngModel">
          <small *ngIf="FechaIni.invalid && FechaIni.touched" class="form-text text-danger animated fadeIn">Campo Obligatorio</small>
      </div>

       <div class="form-group col-md-2">
        <label for="inputPassword4">Fecha Final</label>
         <input [(ngModel)]="reporte.fechaFin" type="date" class="form-control" name="FechaFin" id="inputAddress" placeholder="" required #FechaFin="ngModel">
          <small *ngIf="FechaFin.invalid && FechaFin.touched" class="form-text text-danger animated fadeIn">Campo Obligatorio</small>
      </div>
   
       <div class="form-group col-md-4">
        <label for="inputPassword4">Partida</label>
        <select [(ngModel)]="reporte.partida" id="areaEmite" class="form-control" name="Partida" required required ngModel #Partida="ngModel">       
          <option value="">Seleccione...</option>
            <ng-container *ngFor="let partida of partidas" >
                <option [value]="partida.id">{{partida.clave}}--{{partida.descripcion}} </option>
          </ng-container>
          </select>
          <small *ngIf="Partida.invalid && Partida.touched" class="form-text text-danger animated fadeIn">Campo Obligatorio</small>
      </div>

       <div class="form-group col-md-2">
        <label for="inputPassword4">Fecha del reporte</label>
         <input [(ngModel)]="reporte.fechaReporte" type="date" class="form-control" name="FechaReporte" id="inputAddress" placeholder="" required #FechaReporte="ngModel">
          <small *ngIf="FechaReporte.invalid && FechaReporte.touched" class="form-text text-danger animated fadeIn">Campo Obligatorio</small>
      </div>


       <div class="form-group col-md-2">

           <div class="boton" style="margin: 0 auto;text-align: center;margin-top: 17px;">
             <button type="submit" class="btn btn-light" title="Generar Reporte" style="font-size: 30px;"><i class="mdi mdi-file-pdf-box" style="color: #ac0808;font-size: 50x;"></i> </button>
           </div>
   
      </div>
    
</div>


</form>

</div>



 <!-- reporte 2 por proveedor -->

 <div class="titulo" style="margin: 0 auto;text-align: center;margin-top: 50px;">

    <h3><b>Reporte de entradas por proveedor </b></h3>
    <hr>
</div>


 <div class="contendor d-flex justify-content-center align-items-center" style="width: 90%;margin: 0 auto;">

    <form (ngSubmit)="GeneraReportePorProveedor(f2)" #f2="ngForm" style="width: 80%;" >

    <div class="form-row mt-5">
      
      <div class="form-group col-md-2">
        <label for="inputPassword4">Fecha Inicial</label>
         <input [(ngModel)]="reporte2.fechaIni" type="date" class="form-control" name="FechaIni2" id="inputAddress" placeholder="" required #FechaIni2="ngModel">
          <small *ngIf="FechaIni2.invalid && FechaIni2.touched" class="form-text text-danger animated fadeIn">Campo Obligatorio</small>
      </div>

       <div class="form-group col-md-2">
        <label for="inputPassword4">Fecha Final</label>
         <input [(ngModel)]="reporte2.fechaFin" type="date" class="form-control" name="FechaFin2" id="inputAddress" placeholder="" required #FechaFin2="ngModel">
          <small *ngIf="FechaFin2.invalid && FechaFin2.touched" class="form-text text-danger animated fadeIn">Campo Obligatorio</small>
      </div>
   
        <div class="form-group col-md-4">
        <label for="inputPassword4">Proveedor</label>
        <select [(ngModel)]="reporte2.idproveedor" id="areaEmite" class="form-control" name="Proveedor2" [(ngModel)]="direccionSeleccionada" (change)="CapturarValor()"  required ngModel #Proveedor2="ngModel">       
          <ng-container *ngFor="let proveedor of proveedores">
                <option [value]="proveedor.id">{{proveedor.razon_social}}</option>
          </ng-container>
          </select>
          <small *ngIf="Proveedor2.invalid && Proveedor2.touched" class="form-text text-danger animated fadeIn">Campo Obligatorio</small>
      </div>

       <div class="form-group col-md-2">
        <label for="inputPassword4">Fecha del reporte</label>
         <input [(ngModel)]="reporte2.fechaReporte" type="date" class="form-control" name="FechaReporte2" id="inputAddress" placeholder="" required #FechaReporte2="ngModel">
          <small *ngIf="FechaReporte2.invalid && FechaReporte2.touched" class="form-text text-danger animated fadeIn">Campo Obligatorio</small>
      </div>


       <div class="form-group col-md-2">

           <div class="boton" style="margin: 0 auto;text-align: center;margin-top: 17px;">
             <button type="submit" class="btn btn-light" title="Generar Reporte" style="font-size: 30px;"><i class="mdi mdi-file-pdf-box" style="color: #ac0808;font-size: 50x;"></i> </button>
           </div>
   
      </div>

    
 </div>

    </form>

 </div>

    <hr>


